import CircularProgress from '@mui/material/CircularProgress';
import globals from '../globals';

const LoadingIcon = ({sx}) => {
    return (
        <>
            <CircularProgress sx={{ color: globals.colors.lightRed, ...sx}} />
        </>
    );
}

export default LoadingIcon;